import { Alignment, Fit, Layout } from '@rive-app/react-canvas';

import { BUCKET_PREFIX } from '../../utils/environment';

export const RIVE_DEFAULTS = {
  STATE_MACHINE_NAME: 'State Machine 1',
  TIMEOUT: 15000,
  LAYOUT: new Layout({
    fit: Fit.Contain,
    alignment: Alignment.Center,
  }),
};

export const RIVE_WASM_RESOURCE = `${BUCKET_PREFIX}rive-wasm/rive-app-canvas-2.37.6.wasm`;
